import { Application } from "@hotwired/stimulus"
import MobileFlashController from "./mobile_flash_controller"
import NativeSessionController from "./native_session_controller"
import OfferedDishController from "./offered_dish_controller"
import SecretController from "./secret_controller"
import UtilityController from "./utility_controller"

const application = Application.start()

application.register("mobile-flash", MobileFlashController)
application.register("native-session", NativeSessionController)
application.register("offered-dish", OfferedDishController)
application.register("secret", SecretController)
application.register("utility", UtilityController)
